

























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";

@Component({
  components: {
      DateComponent
  }
})
export default class ProjectInfoComponent extends Vue {
    @Prop() tracker: any;   

    extendedDateKey: number = 1;

}
